import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GenericPromises from '../../../../../api/GenericPromises';
import { FormsErrors } from '../../../../../hooks/Forms/FormsErrors';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { PrimaryButton } from '../../../../../theme/buttons';
import { HazardousMaterialKey } from '../../../../../interfaces/Sales/Catalogs/TransportationDocuments/hazardousMaterialsKeys';
import useSnackBar from '../../../../../components/Commons/SnackBar/useSnackBar';


export const UpdateHazardousMaterialsKeys = ({ ...props }) => {
    const [t] = useTranslation("global");
    const { GenericPutResource } = GenericPromises();
    const { showSnackBar, SnackbarComponent } = useSnackBar();
    const { GetError } = FormsErrors();
    const [loadingPost, setLoadingPost] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const { hazardousMaterialsKeyPayload } = props;
    const isEdit = !props.isEdit;

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<HazardousMaterialKey>({
        defaultValues: {
            hazardous_material_key: '',
            hazardous_material_description: '',
        }
    });
    const onSubmit: SubmitHandler<HazardousMaterialKey> = (data) => onPut(data);

    const onPut = (data: HazardousMaterialKey) => {
        let myData = {
            hazardous_material_key: data.hazardous_material_key,
            hazardous_material_description: data.hazardous_material_description,
        }
        setLoadingPost(true);
        GenericPutResource(`/hazardousmaterialskeys/${hazardousMaterialsKeyPayload.hazardous_material_key_id}`, myData)
            .then((response) => {
                showSnackBar(t("generic.snackbar.update"), "success");
                setLoadingPost(false);
            })
            .catch((error) => {
                setLoadingPost(false);
                showSnackBar(error.message, 'error');
            });
    }

    useEffect(() => {
        reset({
            hazardous_material_key: hazardousMaterialsKeyPayload.hazardous_material_key,
            hazardous_material_description: hazardousMaterialsKeyPayload.hazardous_material_description,
        });
        setDataLoaded(true);
    }, []);

    return (
        <>
            {dataLoaded &&
                <div className='d-flex justify-content-center'>
                    <div className='custom-card-view w-75'>

                        <form onSubmit={handleSubmit(onSubmit)} className='mt-4'>

                            <div className="custom-card-row d-flex justify-content-between">

                                <div className="w-100">
                                    <div className='d-flex w-100'>
                                        <div className='w-50'>
                                            <Controller
                                                name="hazardous_material_key"
                                                control={control}
                                                rules={{ required: true, maxLength: 4 }}
                                                render={({ field }) =>
                                                    <TextField
                                                        variant="filled"
                                                        label={`${t("hazardousmaterialskeys.fields.hazardous_material_key")}`}
                                                        ref={field.ref}
                                                        value={field.value}
                                                        onChange={(event) => { field.onChange(event.target.value) }}
                                                        error={!!errors.hazardous_material_key}
                                                        helperText={GetError(errors.hazardous_material_key?.type)}
                                                        size="small"
                                                        style={{ width: "100%" }}
                                                        sx={{ paddingRight: 2 }}
                                                        disabled={isEdit}
                                                    />
                                                }
                                            />
                                        </div>
                                        <div className='w-50'>
                                            <Controller
                                                name="hazardous_material_description"
                                                control={control}
                                                rules={{ maxLength: 100 }}
                                                render={({ field }) =>
                                                    <TextField
                                                        variant="filled"
                                                        label={`${t("hazardousmaterialskeys.fields.hazardous_material_description")}`}
                                                        ref={field.ref}
                                                        value={field.value}
                                                        onChange={(event) => { field.onChange(event.target.value) }}
                                                        error={!!errors.hazardous_material_description}
                                                        helperText={GetError(errors.hazardous_material_description?.type)}
                                                        size="small"
                                                        style={{ width: "100%" }}
                                                    />
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {!isEdit &&
                                <div className='d-flex flex-row-reverse mt-4'>
                                    <PrimaryButton type='submit' variant='outlined' className='m-1' disabled={loadingPost}>{t("generic.buttons.update")}</PrimaryButton>
                                </div>
                            }

                        </form>

                    </div>
                </div>
            }
            <SnackbarComponent />
        </>
    )
}
